var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMktgEmailShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 54",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 8.01H13.1c-2.36 0-4.28 2.05-4.28 4.56l-.03 36.46c0 2.5 1.94 4.56 4.3 4.56H59c2.37 0 4.31-2.05 4.31-4.56V12.57c0-2.5-1.94-4.56-4.3-4.56z",
    fill: "#ccc6d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.64.71a7.1 7.1 0 017.04 7.12v34.19a7.1 7.1 0 01-7.04 7.12h-45A7.1 7.1 0 01.6 42.02L.63 7.83a7.07 7.07 0 017-7.12zm0 2.85h-45a4.24 4.24 0 00-4.2 4.28L3.4 42.02c0 2.35 1.9 4.27 4.22 4.27h45.02a4.26 4.26 0 004.22-4.27V7.83c0-2.34-1.9-4.27-4.22-4.27zm-3.4 9.28L29.88 24.93 10.55 12.84V8.01L29.89 20.1 49.23 8.01v4.83z",
    fill: "#444"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-mktg--email-shadow-b26de542e1bee48ae495e2e6fb78ddf6.svg";
export { SvgIconMktgEmailShadow as Component };